export const state = () => ({
  selectedCategory: null,
  selectedCategoryId: null,

  productSelectedCategory: [],
  selectedProducts: [],

  selectedFilters: {},
  initialFilters: {},
  filterDataSelectedCategory: [],

  selectedWheelSetCount: 1,

  isLoadingCategory: false,
  isLoadingFilterData: false,
  isLoadingProduct: false,
});

export const mutations = {
  setSelectedFilters: function (state, selectedFilters) {
    state.selectedFilters = selectedFilters;
  },
  setSelectedCategory: function (state, selectedCategory) {
    state.selectedCategory = selectedCategory;
  },
  setFilterDataSelectedCategory: function (state, filterDataSelectedCategory) {
    state.filterDataSelectedCategory = filterDataSelectedCategory;
  },
  setProductSelectedCategory: function (state, productSelectedCategory) {
    state.productSelectedCategory = productSelectedCategory;
  },
  setSelectedWheelSetCount: function (state, count) {
    state.selectedWheelSetCount = count;
  },
  setSelectedProducts: function (state, selectedProducts) {
    state.selectedProducts = selectedProducts;
  },
  setInitialFilters: function (state, initialFilters) {
    state.initialFilters = initialFilters;
  },

  changeLoading: function (state, { name, value }) {
    state[name] = value;
  },
};

export const actions = {
  getSelectedCategory: async function ({ state, commit, dispatch }, categorId) {
    commit('setSelectedFilters', { ...(state?.initialFilters || {}) });
    commit('changeLoading', { name: 'isLoadingCategory', value: true });
    const category = await this.$api.agent.transport.get(`/categories/${categorId}`).then((res) => res.data).catch(() => null);
    await commit('setSelectedCategory', category);
    await dispatch('getFilterData');
    await dispatch('getProducts');
    commit('changeLoading', { name: 'isLoadingCategory', value: false });
  },
  getFilterData: async function ({ state, commit }) {
    const selectedFilters = { ...state.selectedFilters };
    delete selectedFilters.profil;

    const filterUrl = selectedFiltersToFiltersUrl(selectedFilters);

    const filterData = await this.$api.agent.transport.get(`/categories/${state.selectedCategory?.id}/filter-data?${filterUrl}&active=0`).then((res) => (res.data?.options || [])).catch((err) => ([]));
    commit('setFilterDataSelectedCategory', filterData);
  },
  getProducts: async function ({ state, commit }) {
    const selectedFilters = { ...state.selectedFilters };
    delete selectedFilters.profil;

    const filterUrl = selectedFiltersToFiltersUrl(selectedFilters);
    const products = await this.$api.agent.transport.get(`/categories/${state.selectedCategory?.id}/products?per-page=999&${filterUrl}&expand=short_characteristics,options,modifications`).then((res) => res.data).catch(() => []);
    commit('setProductSelectedCategory', products);
  },

  changeSelectedFilters: async function ({ commit, dispatch }, selectedFilters) {
    commit('setSelectedFilters', selectedFilters);
    commit('changeLoading', { name: 'isLoadingCategory', value: true });
    await dispatch('getFilterData');
    await dispatch('getProducts');
    commit('changeLoading', { name: 'isLoadingCategory', value: false });
  },
};

const selectedFiltersToFiltersUrl = (selectedFilters) => {
  const filtersUrl = [];
  Object.keys(selectedFilters).map((filterSlug) => {
    const variants = Object
      .keys(selectedFilters[filterSlug])
      .map((value) => {
        filtersUrl.push(`filter[${filterSlug}][]=${value}`);
      });
  });
  return filtersUrl.join('&');
};
